// widget/src/util.ts

/** Compose classnames, dropping falsy entries. */
export function cn(
  ...args: Array<string | false | null | undefined>
): string {
  return args.filter(Boolean).join(" ")
}
